import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class MultisiteBenefitsPackageModal extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#multisite-benefits-package-form-modal',
			triggerSelectors: ['.js-multisite-benefits-package-trigger'],
			stepsEndpointAttr: 'benefits-package-steps-endpoint',
			submitEndpointAttr: 'benefits-package-submit-endpoint',
			wrapperSelector: '.p-venue-registeration-landing-multisite-with-venue',
			sectionWrapperSelector: '.p-venue-registration-landing-wrapper',
			logPrefix: 'MultisiteBenefitsPackageModal'
		});
	}

	init() {
		super.init();
		if (!this.stepsEndpoint) {
			this.stepsEndpoint = '/api/venueRegistration/benefitsPackage/multisite/steps';
		}
		if (!this.submitEndpoint) {
			this.submitEndpoint = '/api/venueRegistration/benefitsPackage/multisite/submit';
		}
	}

	getRequestParam() {
		const params = super.getRequestParam() || {};
		return {
			...params,
			mode: 'multiple'
		};
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: true,
			isBackButtonEnabled: true,
			radioAnswerField: 'id',
			exitButtonLabel: 'Save and Exit',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',		
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			nextStepButtonLabel: 'Save and continue',
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}
}

VenueRegistrationFormModal.boot(MultisiteBenefitsPackageModal);

export default MultisiteBenefitsPackageModal;
